var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDistribute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 18.2207,
    width: 44,
    height: 44,
    rx: 8,
    fill: "#1E2A10"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1881_1879)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.1318,
    cy: 37.4849,
    r: 13.1094,
    fill: "#AAEF77"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1752 56.1595C36.6307 56.1595 43.4852 49.305 43.4852 40.8495C43.4852 32.3941 36.6307 25.5396 28.1752 25.5396C19.7198 25.5396 12.8652 32.3941 12.8652 40.8495C12.8652 49.305 19.7198 56.1595 28.1752 56.1595Z",
    fill: "url(#paint0_linear_1881_1879)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1752 56.1595C36.6307 56.1595 43.4852 49.305 43.4852 40.8495C43.4852 32.3941 36.6307 25.5396 28.1752 25.5396C19.7198 25.5396 12.8652 32.3941 12.8652 40.8495C12.8652 49.305 19.7198 56.1595 28.1752 56.1595Z",
    fill: "url(#paint1_radial_1881_1879)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2152 43.7397C46.681 40.828 46.434 37.8467 45.4953 35.0514C44.5565 32.2561 42.9541 29.73 40.8252 27.6897L45.0352 23.1997",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1754 56.1595C33.9412 56.1595 38.6154 49.305 38.6154 40.8495C38.6154 32.3941 33.9412 25.5396 28.1754 25.5396C22.4095 25.5396 17.7354 32.3941 17.7354 40.8495C17.7354 49.305 22.4095 56.1595 28.1754 56.1595Z",
    stroke: "url(#paint2_linear_1881_1879)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1752 49.971C36.6307 49.971 43.4852 45.8878 43.4852 40.851C43.4852 35.8141 36.6307 31.731 28.1752 31.731C19.7198 31.731 12.8652 35.8141 12.8652 40.851C12.8652 45.8878 19.7198 49.971 28.1752 49.971Z",
    stroke: "url(#paint3_linear_1881_1879)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1758 56.1704V25.6704",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1758 56.1704V25.6704",
    stroke: "url(#paint4_linear_1881_1879)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9355 40.9204H43.4255",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9355 40.9204H43.4255",
    stroke: "url(#paint5_linear_1881_1879)",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9955 26.3001C46.7076 26.3001 48.0955 24.9122 48.0955 23.2001C48.0955 21.488 46.7076 20.1001 44.9955 20.1001C43.2834 20.1001 41.8955 21.488 41.8955 23.2001C41.8955 24.9122 43.2834 26.3001 44.9955 26.3001Z",
    fill: "url(#paint6_linear_1881_1879)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9955 26.3001C46.7076 26.3001 48.0955 24.9122 48.0955 23.2001C48.0955 21.488 46.7076 20.1001 44.9955 20.1001C43.2834 20.1001 41.8955 21.488 41.8955 23.2001C41.8955 24.9122 43.2834 26.3001 44.9955 26.3001Z",
    fill: "url(#paint7_radial_1881_1879)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4858 23.2109C29.6261 22.5018 26.6373 22.4953 23.7745 23.1918C20.9118 23.8884 18.2601 25.2673 16.0458 27.2109L11.9258 22.6509",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0902 25.306C13.8023 25.306 15.1902 23.918 15.1902 22.206C15.1902 20.4939 13.8023 19.106 12.0902 19.106C10.3782 19.106 8.99023 20.4939 8.99023 22.206C8.99023 23.918 10.3782 25.306 12.0902 25.306Z",
    fill: "url(#paint8_linear_1881_1879)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0902 25.306C13.8023 25.306 15.1902 23.918 15.1902 22.206C15.1902 20.4939 13.8023 19.106 12.0902 19.106C10.3782 19.106 8.99023 20.4939 8.99023 22.206C8.99023 23.918 10.3782 25.306 12.0902 25.306Z",
    fill: "url(#paint9_radial_1881_1879)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7255 35.7095C9.87147 38.531 9.71558 41.5177 10.2713 44.4128C10.8269 47.3079 12.0775 50.0247 13.9155 52.3295L9.14551 56.2195",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2148 58.8996C28.1223 59.3834 31.1036 59.1558 33.9039 58.2363C36.7042 57.3168 39.2401 55.7328 41.2948 53.6196L45.7548 57.8596",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5854 61.3353C48.2974 61.3353 49.6854 59.9473 49.6854 58.2353C49.6854 56.5232 48.2974 55.1353 46.5854 55.1353C44.8733 55.1353 43.4854 56.5232 43.4854 58.2353C43.4854 59.9473 44.8733 61.3353 46.5854 61.3353Z",
    fill: "url(#paint10_linear_1881_1879)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5854 61.3353C48.2974 61.3353 49.6854 59.9473 49.6854 58.2353C49.6854 56.5232 48.2974 55.1353 46.5854 55.1353C44.8733 55.1353 43.4854 56.5232 43.4854 58.2353C43.4854 59.9473 44.8733 61.3353 46.5854 61.3353Z",
    fill: "url(#paint11_radial_1881_1879)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09024 60.306C9.80232 60.306 11.1902 58.918 11.1902 57.206C11.1902 55.4939 9.80232 54.106 8.09024 54.106C6.37815 54.106 4.99023 55.4939 4.99023 57.206C4.99023 58.918 6.37815 60.306 8.09024 60.306Z",
    fill: "url(#paint12_linear_1881_1879)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09024 60.306C9.80232 60.306 11.1902 58.918 11.1902 57.206C11.1902 55.4939 9.80232 54.106 8.09024 54.106C6.37815 54.106 4.99023 55.4939 4.99023 57.206C4.99023 58.918 6.37815 60.306 8.09024 60.306Z",
    fill: "url(#paint13_radial_1881_1879)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1881_1879",
    x: 0.0224609,
    y: 0.375488,
    width: 74.2188,
    height: 74.2188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_1881_1879"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1881_1879",
    x1: 0.534561,
    y1: -18.7772,
    x2: 20.5613,
    y2: 65.7326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEF77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764629,
    stopColor: "#F8FCF5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1881_1879",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.6593 51.2145) rotate(-96.4698) scale(31.4871 36.597)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84D349",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D349"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1881_1879",
    x1: 28.1754,
    y1: 25.5396,
    x2: 28.1754,
    y2: 56.1595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1881_1879",
    x1: 28.1752,
    y1: 31.731,
    x2: 28.1752,
    y2: 49.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1881_1879",
    x1: 28.6758,
    y1: 25.6704,
    x2: 28.6758,
    y2: 56.1704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1881_1879",
    x1: 28.1805,
    y1: 40.9204,
    x2: 28.1805,
    y2: 41.9204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1881_1879",
    x1: 44.9955,
    y1: 18.5382,
    x2: 44.6087,
    y2: 27.1544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEF77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FCF5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1881_1879",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.6951 29.0643) rotate(-88.0218) scale(8.70067 10.1127)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452749,
    stopColor: "#84D349",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55A817"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1881_1879",
    x1: 12.0902,
    y1: 17.5441,
    x2: 11.7035,
    y2: 26.1603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEF77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FCF5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1881_1879",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.7899 28.0702) rotate(-88.0218) scale(8.70067 10.1127)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452749,
    stopColor: "#84D349",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55A817"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1881_1879",
    x1: 46.5853,
    y1: 53.5734,
    x2: 46.1986,
    y2: 62.1896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEF77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FCF5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1881_1879",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.285 64.0995) rotate(-88.0218) scale(8.70067 10.1127)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452749,
    stopColor: "#84D349",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55A817"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1881_1879",
    x1: 8.09021,
    y1: 52.5441,
    x2: 7.70347,
    y2: 61.1603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEF77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FCF5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1881_1879",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.78987 63.0702) rotate(-88.0218) scale(8.70067 10.1127)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452749,
    stopColor: "#84D349",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55A817"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDistribute);
export default __webpack_public_path__ + "static/media/icon-distribute.9a8162e396458d09a38925c4016d6299.svg";
export { ForwardRef as ReactComponent };